import { render, staticRenderFns } from "./WarehouseCustom.vue?vue&type=template&id=813b4b28&"
import script from "./WarehouseCustom.vue?vue&type=script&lang=js&"
export * from "./WarehouseCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports